var React = require('react');

function IcRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z","fill":"currentColor"}));
}

IcRight.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IcRight;

IcRight.default = IcRight;
